/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskIncidentManagementType from '@jira/spa-apps__project-settings-service-desk-incident-management-settings/src/ServiceDeskIncidentManagementSettingsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskIncidentManagement: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskIncidentManagementType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-incident-management", jiraSpaEntry: "async-project-settings-service-desk-incident-management" */ '@jira/spa-apps__project-settings-service-desk-incident-management-settings/src/ServiceDeskIncidentManagementSettingsPage.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskIncidentManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskIncidentManagement}
		pageId="project-settings-incident-management"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskIncidentManagement;
